/**
 * Created by qx on 2018/12/25.
 */
import { get, post, put } from '../../http'
const ORDER_ADVERTISER_MENU = 'ORDER_ADVERTISER_MENU' // 所属广告主下拉菜单
const ORDER_INDUSTRY_MENU = 'ORDER_INDUSTRY_MENU' // 广告行业下拉菜单
const ORDER_FLOW_TYPE_MENU = 'ORDER_FLOW_TYPE_MENU' // 流量类型
const ORDER_PORT_TYPE_MENU = 'ORDER_PORT_TYPE_MENU' // 投放终端
const ORDER_MEDIA_MENU = 'ORDER_MEDIA_MENU' // 媒体名称
const ORDER_PLACE_ATTRIBUTE_MENU = 'ORDER_PLACE_ATTRIBUTE_MENU' // 广告位属性
const ORDER_CHANNEL_TYPE_MENU = 'ORDER_CHANNEL_TYPE_MENU' // 信息流下拉菜单
const ORDER_CHANNEL_MENU = 'ORDER_CHANNEL_MENU' // 频道下拉菜单
const ORDER_POSITION_MENU = 'ORDER_POSITION_MENU' // 广告位下拉菜单
const ORDER_PROVINCES_CLASS_MENU = 'ORDER_PROVINCES_CLASS_MENU' // 地域
const ORDER_PAYMENT_MENU = 'ORDER_PAYMENT_MENU' // 结算方式
const ORDER_CAROUSEL_MENU = 'ORDER_CAROUSEL_MENU' // 轮播方式
const ORDER_CHANGE_MEDIA_TYPE = 'ORDER_CHANGE_MEDIA_TYPE' // 计划模板媒体区分
const ORDER_CHANGE_NAME_MENU = 'ORDER_CHANGE_NAME_MENU' // 渠道名称下拉菜单
const ORDER_PRORITY_MENU = 'ORDER_PRORITY_MENU' // 优先级下拉菜单
const state = {
  orderManage: {
    advertiserMenu: [],
    curAdvertiser: '',
    mediaType: 'radio',
    industryMenu: [],
    flowTypeMenu: [],
    curFlowType: '',
    portTypeMenu: [],
    curPortType: '',
    mediaMenu: [],
    curMedia: undefined,
    channelNameMenu: [],
    curChannelName: undefined,
    placeAttrMenu: [],
    curPlaceAttr: '',
    channelTypeMenu: [],
    curChannelType: '',
    channelMenu: [],
    curChannel: '',
    positionMenu: [],
    curPosition: '',
    areaMenu: {
      entire: [],
      provinces: []
    },
    paymentMenu: [],
    carouselMenu: [],
    prorityMenu: []
  }
}

const getters = {
  orderManage: state => state.orderManage
}

const actions = {
  async orderItem({ state, commit }, { data, platform }) {
    // 获取通某用列表数据
    let response = await get('/interface/etcd/item/' + data + '?platform=' + platform)
    return response
  },
  async orderNameIsRepeat({ state, commit }, { data, mediaType }) {
    let api = mediaType !== 'radio' ? 'global-order' : 'order'
    let response = await get('/admin/' + api + '/is-repeated', { name: data })
    return response
  },
  async advertiserList({ state, commit }) {
    await get('/admin/advertiser/adminselect').then(res => {
      if (res.code === 1) {
        commit(ORDER_ADVERTISER_MENU, { result: res.data })
      }
    })
  },
  async payment({ state, commit }, { data }) {
    let response = await get('/admin/order/place', data)
    return response
  },
  async adPlace({ state, commit }, { data }) {
    let response = await get('/admin/order/place', data)
    return response
  },
  async searchPlace({ state, commit }, { data }) {
    // 模糊查询媒体
    let response = await get('/admin/order/places', data)
    return response
  },
  async someItem({ state, commit }, { params, data }) {
    // 终端，支付方式
    let response = await get('/interface/etcd/item/' + params, data)
    return response
  },
  async getEtcdItem({ state, commit }, { params, data, api, mediaType } = {}) {
    let urlKey = params === 'payment-radio' || params === 'payment-reelection' ? 'place/' : 'etcd/item/'
    await get('/interface/' + urlKey + params, data).then(data => {
      if (data.code === 1) {
        commit(api, { result: data.data, mediaType, data })
      }
    })
  },
  async  proritySelect({ state, commit }, { data } = {}) {
    await get('/v2/prority').then(res => {
      if (res.code === 1) {
        commit(ORDER_PRORITY_MENU, { result: res.data })
      }
    })
  },
  async getCommonPlace({ state, commit }, { params, data, api, isAll, mediaType } = {}) {
    if (params === 'place_attribute') {
      if (state.orderManage.mediaType === 'checkbox' && typeof data.media === 'object') {
        let str = ''
        data.media.forEach(res => {
          str += `${res},`
        })
        data.medias = str
        delete data.media
      } else if (state.orderManage.mediaType === 'global') {
        data.medias = -1
        delete data.media
      }
    } else if (params === 'media') {
      if (state.orderManage.mediaType === 'checkbox' && typeof data.pMedia === 'object') {
        let str = ''
        data.pMedia.forEach(res => {
          str += `${res},`
        })
        data.pMedia = str
      } else if (state.orderManage.mediaType === 'global') {
        data.pMedia = -1
      }
    }

    await get('/interface/place/attribute/' + params, data).then(res => {
      if (res.code === 1) {
        commit(api, { result: res.data, isAll, mediaType, data })
      }
    })
  },
  async orderAllItem({ state, commit }) {
    // 获取通用所有列表数据
    let response = await get('/interface/etcd/list')
    return response
  },
  async orderList({ state, commit }, { data }) {
    // 计划列表 / 查看计划
    let api = state.orderManage.mediaType !== 'radio' ? 'global-order' : 'order'
    let response
    if (state.orderManage.mediaType === 'checkbox' && typeof data.media === 'object') {
      let str = ''
      data.media.forEach(res => {
        str += `${res},`
      })
      delete data.media
      data.medias = str
    } else if (state.orderManage.mediaType === 'global') {
      data.medias = -1
    }
    if (data && data.orderId) {
      response = await get('/admin/' + api + '/' + data.orderId)
    } else {
      response = await get('/admin/' + api + '/', data)
    }
    return response
  },
  async addOrder({ state, commit }, { data }) {
    // 添加计划
    let response = await post('/admin/order', data)
    return response
  },
  async updateOrder({ state, commit }, { data, id }) {
    // 更新计划
    let response = await put(`/admin/order/${id}`, data)
    return response
  },
  async stopOrder({ state, commit }, { data, mediaType }) {
    // 停止计划
    let api = mediaType !== 'radio' ? 'global-order' : 'order'
    let response = await get('/admin/' + api + '/stop/' + data.id)
    return response
  },
  async switchOrder({ state, commit }, { data }) {
    // 改变计划状态
    let response = await get('/admin/order/change-status/' + data.id)
    return response
  },
  async batchStart({ state, commit }, { data }) {
    // 批量启动
    let response = await post('/admin/order/batch-begin', data)
    return response
  },
  async batchStop({ state, commit }, { data }) {
    // 批量暂停
    let response = await post('/admin/order/batch-pause', data)
    return response
  },
  async getPosition({ state, commit }, { params, isAll } = {}) {
    await get('/admin/order/place', params).then(res => {
      if (res.code === 1) {
        commit(ORDER_POSITION_MENU, { result: res.data, isAll })
      }
    })
  }
}

const mutations = {
  [ORDER_ADVERTISER_MENU](state, result) {
    state.orderManage.advertiserMenu = result.result
  },
  [ORDER_INDUSTRY_MENU](state, result) {
    state.orderManage.industryMenu = result.result
  },
  [ORDER_PRORITY_MENU](state, result) {
    state.orderManage.prorityMenu = result.result
  },
  [ORDER_FLOW_TYPE_MENU](state, result) {
    let arr = {}
    arr.name = '选择流量类型'
    arr.value = ''
    state.orderManage.flowTypeMenu = result.result
    if (result.isAll) {
      state.orderManage.flowTypeMenu.unshift(arr)
    }
    state.orderManage.curFlowType = result.result.length ? result.result[0].value : ''
  },
  [ORDER_PORT_TYPE_MENU](state, result) {
    let arr = {}
    arr.name = '选择终端'
    arr.value = ''
    state.orderManage.portTypeMenu = result.result
    if (result.isAll) {
      state.orderManage.portTypeMenu.unshift(arr)
    }
    state.orderManage.curPortType = result.result.length ? result.result[0].value : ''
  },
  [ORDER_MEDIA_MENU](state, result) {
    let arr = {}
    arr.name = '选择媒体'
    arr.value = ''
    state.orderManage.mediaMenu = result.result
    if (result.isAll) {
      state.orderManage.mediaMenu.unshift(arr)
    }
    let curMedia = result.result.length ? result.result[0].value : ''
    state.orderManage.curMedia =
      result.mediaType === 'checkbox' ? [curMedia] : result.mediaType === 'radio' ? curMedia : ''
  },
  [ORDER_CHANGE_NAME_MENU](state, result) {
    let arr = {}
    arr.name = '选择渠道'
    arr.value = ''
    state.orderManage.channelNameMenu = result.result
    if (result.isAll) {
      state.orderManage.channelNameMenu.unshift(arr)
    }
    state.orderManage.channelNameMenu = result.result
    if (result.mediaType === 'checkbox' && result.data.pMedia) {
      /* let arr = []
      if (result.result.length && result.data.pMedia) {
        result.result.forEach(res => {
          arr.push(res.value)
        })
      } */
      // state.orderManage.curChannelName = arr
    } else if (result.mediaType === 'radio') {
      state.orderManage.curChannelName = result.result.length ? result.result[0].value : ''
    } else {
      state.orderManage.curChannelName = ''
    }
  },
  [ORDER_PLACE_ATTRIBUTE_MENU](state, result) {
    let arr = {}
    arr.name = '选择广告位属性'
    arr.value = ''
    state.orderManage.placeAttrMenu = result.result
    if (result.isAll) {
      state.orderManage.placeAttrMenu.unshift(arr)
    }
    state.orderManage.curPlaceAttr = result.result.length ? result.result[0].value : ''
  },
  [ORDER_CHANNEL_TYPE_MENU](state, result) {
    let arr = {}
    arr.name = '选择频道类型'
    arr.value = ''
    state.orderManage.channelTypeMenu = result.result
    if (result.isAll) {
      state.orderManage.channelTypeMenu.unshift(arr)
    }
    state.orderManage.curChannelType = result.result.length ? result.result[0].value : ''
  },
  [ORDER_CHANNEL_MENU](state, result) {
    let arr = {}
    arr.name = '选择频道'
    arr.value = ''
    state.orderManage.channelMenu = result.result
    if (result.isAll) {
      state.orderManage.channelMenu.unshift(arr)
    }
    state.orderManage.curChannel = result.result.length ? result.result[0].value : ''
  },
  [ORDER_POSITION_MENU](state, result) {
    let arr = {}
    arr.name = '选择广告位'
    arr.value = ''
    state.orderManage.positionMenu = result.result
    if (result.isAll) {
      state.orderManage.positionMenu.unshift(arr)
    }
    state.orderManage.curPosition = result.result.length ? result.result[0].value : ''
  },
  [ORDER_PROVINCES_CLASS_MENU](state, result) {
    state.orderManage.areaMenu = result.result
  },
  [ORDER_PAYMENT_MENU](state, result) {
    state.orderManage.paymentMenu = result.result
  },
  [ORDER_CAROUSEL_MENU](state, result) {
    state.orderManage.carouselMenu = result.result
  },
  [ORDER_CHANGE_MEDIA_TYPE](state, result) {
    state.orderManage.mediaType = result.type
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
